var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    { staticClass: "label", attrs: { for: _vm.forInput } },
    [
      _vm.text
        ? _c("span", [
            _vm._v(_vm._s(_vm.text)),
            _vm.required ? _c("sup", [_vm._v(" *")]) : _vm._e()
          ])
        : _vm._e(),
      _vm.iconClass ? _c("span", { class: _vm.iconClass }) : _vm._e(),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10faa5fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10faa5fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/_UI/BaseLabel.vue
// module id = 4ljR
// module chunks = 13